export default __webpack_public_path__ + "static/media/icon6.a9cb4ff8.png";